// Copyright (c) 2016 Deere & Company

import actions from '../../../action-list';

export const updatePin = pin => ({
    pin,
    type: actions.UPDATE_CLAIM_MAINTENANCE_PLAN_PIN
});



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/action-creators/pin.js